import React, { FC, lazy, Suspense } from 'react'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'

import WithRoutePermission from 'routes/guards/withRoutePermission'
import RequiredRole from 'routes/guards/requiredRole'
import AccountSettingsPageContainer from 'settings/accountSettings'
import { PageLoader } from 'uiComponents/loaders'
import { BaseRouteParams } from 'hocs'


const Integrations = lazy(() => import('settings/accountSettings/integrations'))
const ContractSection = lazy(() => import('settings/accountSettings/contract'))
const AccountInfoSection = lazy(() => import('settings/accountSettings/accountInfo'))
const BookingFeesSection = lazy(() => import('settings/accountSettings/bookingFees'))
const TaxConfigurationsSection = lazy(() => import('settings/accountSettings/taxConfigurations'))
const ReportingCategoriesTable = lazy(() => import('settings/accountSettings/reportingCategories'))
const PaymentMethods = lazy(() => import('settings/accountSettings/paymentMethods'))

const AccountRoutes: FC<RouteComponentProps<BaseRouteParams>> = ({ match }) => {
    return (
        <WithRoutePermission requiredPermissions={['partner_admin']}>
            <AccountSettingsPageContainer>
                <Suspense fallback={<PageLoader />}>
                    <Switch>
                        <Route
                            path="/account/:accountSlug/settings/account_settings/account_info"
                            component={AccountInfoSection}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/booking_fees"
                            component={BookingFeesSection}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/tax_configurations"
                            component={TaxConfigurationsSection}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/contract"
                            component={() => (
                                <RequiredRole role="convious_admin">
                                    <ContractSection />
                                </RequiredRole>
                            )}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/integrations"
                            component={() => (
                                <RequiredRole role="partner_admin">
                                    <Integrations />
                                </RequiredRole>
                            )}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/reporting_categories"
                            component={ReportingCategoriesTable}
                        />
                        <Route
                            path="/account/:accountSlug/settings/account_settings/payment_methods"
                            component={PaymentMethods}
                        />
                        <Redirect to={`/account/${match.params.accountSlug}/settings/account_settings/account_info`} />
                    </Switch>
                </Suspense>
            </AccountSettingsPageContainer>
        </WithRoutePermission>
    )
}

export default AccountRoutes
